import { useEffect } from 'react';
import { saveItemToLocalStorage } from '~/utilities/localStorage';

// temporary for experiment quali-srp-carvanads
export default function useSetHasVisitedVDP() {
  useEffect(() => {
    saveItemToLocalStorage('srp/hasVisitedVDP', 1);
  }, []);
}
